import { AnalysisSetting, Assertions } from '~/packages/variable/variables.typing'
import { ShapeBase } from '~/prix'
import { Expression } from '~/prix/types/expression'
import { SpaceForPoint } from '~/prix/types/presets/space'
import { iterateAndCheckIfSomeExpression } from '~/prix/utils/expressionUtils'

interface VariableInput {
  variable?: {
    customValue?: Expression<keyof ShapeBase> | null
  } | null
  space?: SpaceForPoint | null
  analysis?: AnalysisSetting | null
  customValue?: Expression<keyof ShapeBase> | null
  filter?: Expression<keyof ShapeBase> | null
  highlight?: Expression<keyof ShapeBase> | null
  assertions?: Assertions | null
  select?: string[] | null
}

export default function checkJoinNeeds(input: VariableInput, propertyKeyOrPrefix: string) {
  if (input.select && input.select.some(key => key.startsWith(propertyKeyOrPrefix))) {
    return true
  }

  const checkProperty = (expression: Expression) =>
    expression.kind === 'property' && expression.property.startsWith(propertyKeyOrPrefix)

  const expressionNeedsJoin = (expression?: Expression | null) =>
    expression ? iterateAndCheckIfSomeExpression(expression, checkProperty) : false

  if (
    expressionNeedsJoin(input.variable?.customValue) ||
    expressionNeedsJoin(input.customValue) ||
    expressionNeedsJoin(input.filter) ||
    expressionNeedsJoin(input.highlight)
  ) {
    return true
  }

  if (input.assertions) {
    return Object.values(input.assertions).some(assertion =>
      expressionNeedsJoin(assertion.expression),
    )
  }

  return false
}
